/* eslint-disable no-underscore-dangle */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import isNil from 'lodash/isNil';
import classNames from 'classnames';
import { OnboardingCard } from '../OnboardingCard';
import { OnboardingStepWizard } from '../OnboardingStepWizard';
import { OnboardingMultiContent } from '../OnboardingMultiContent';
import { Button } from '../Button';
import { removeEmptyObjects } from '../../shared/helpers';
import './OnboardingStep.css';

export const OnboardingStep = ({
  projectId,
  handleCardInputChange,
  handleGoToAnswer,
  currentOnboardingStep,
  currentOverviewStep,
  currentOnboardingSteps,
  handleCardSelected,
  handleNextStep,
  handlePrevStep,
  currentOverviewSteps,
  handleGoToSection,
  handleAddReference,
  handleDeleteReference,
  handleProjectBriefInput,
  handleProjectUpload,
  handleRemoveUpload,
  isUploadingAttachment,
  isUploadingProjectPicture,
  isSavingProject,
  handleReferenceInputChange,
  budget,
  minBudget,
  maxBudget,
  recommendedBudget,
  handleBudgetChange,
  onPricingCalculatorMounted,
  freelancers,
  freelancersPagination,
  handleFetchFreelancers,
  handleFreelancerBookNow,
  handleFreelancerRequestABid,
  handleFreelancerDeleteABid,
  isFetchingFreelancers,
  handleShowFreelancerChooserPopup,
  handleFreelancerCardClicked,
  handleAddDeadline,
  handleAddContactInfo,
  handleSaveManagementWay,
  handleGoToDashboard,
  handleFreeCommentInputChange,
}) => {
  const cardInfoIndex = currentOnboardingSteps[
    currentOverviewStep
  ].onboardingSteps.findIndex(elem => elem.key === currentOnboardingStep);

  const onboardingStepInfo =
    currentOnboardingSteps[currentOverviewStep].onboardingSteps[cardInfoIndex];

  const {
    key,
    deadline,
    references,
    project_name: projectName,
    project_brief: projectBrief,
    current_section: currentSection,
    number_of_sections: sectionsNumber,
  } = onboardingStepInfo;

  const { selectedValue: value } = onboardingStepInfo;
  const selectedValue = isArray(value) ? removeEmptyObjects(value) : value;
  const isMultiSections = sectionsNumber > 0;
  const hasOtherInput = selectedValue.includes('other');

  const cardStep = hasOtherInput
    ? getOtherCard(onboardingStepInfo, isMultiSections, currentSection)
    : {};

  const inputValue = get(cardStep, 'inputValue', '');

  const hasSpecialStep = onboardingStepInfo.cards.find(card => card.isSpecial);

  const enableOther = hasOtherInput ? !_.isEmpty(inputValue) : true;

  const enableTitleBrief =
    key === 'title_brief'
      ? !_.isEmpty(projectName) && !_.isEmpty(projectBrief)
      : true;

  const enableMultipleSteps = isMultiSections
    ? (!currentSection && selectedValue.length > 0) ||
      selectedValue.length >= sectionsNumber
    : true;

  const enableCardStep = (() => {
    if (key === 'project_requirements') {
      return true;
    }
    return !hasSpecialStep ? selectedValue.length > 0 : true;
  })();

  const targetCardStep = (() => {
    if (key === 'audience') {
      return true;
    }
    return !hasSpecialStep ? selectedValue.length > 0 : true;
  })();

  const video_layoutCardStep = (() => {
    if (key === 'video_layout') {
      return true;
    }
    return !hasSpecialStep ? selectedValue.length > 0 : true;
  })();

  const enableUrlLink = true;

  const enableDeadline =
    key === 'deadline'
      ? !_.isEmpty(selectedValue) && !_.isEmpty(projectName)
      : true;

  const enableFiles = key === 'files' ? !_.isEmpty(selectedValue) : true;

  const isNextEnabled =
    enableMultipleSteps &&
    targetCardStep&&
    video_layoutCardStep&&
    enableCardStep &&
    enableUrlLink &&
    enableOther &&
    enableTitleBrief &&
    enableDeadline &&
    enableFiles;

  const attachments = _(onboardingStepInfo.attachments)
    .filter(a => _.isNil(a._destroy))
    .value();

  const renderBrowserButtons = () => {
    let advanceButtonLabel = 'NEXT';

    const { enableSkip } = onboardingStepInfo;

    if (enableSkip) {
      if (selectedValue.length && !selectedValue.join()) {
        advanceButtonLabel = 'SKIP';
      }

      if (!selectedValue.length) {
        advanceButtonLabel = 'SKIP';
      }
    }

    return (
      <div className="w-100 d-flex justify-content-between py-3">
        <Button
          rounded
          inline
          title="PREVIOUS"
          className="btn-outline-primary t-10 t-lg-15 px-6 px-lg-5"
          onClick={handlePrevStep}
        />
        <Button
          rounded
          inline
          title={advanceButtonLabel}
          className="btn-primary t-10 t-lg-15 px-6 px-lg-5"
          onClick={handleNextStep}
          disabled={!isNextEnabled || isSavingProject}
        />
      </div>
    );
  };

  const isBasicRequirement = onboardingStepInfo.key === 'basic_requirements';
  const isVideoFormat = onboardingStepInfo.key === 'format';
  const hasSpecialCard = !isNil(
    onboardingStepInfo.cards.find(card => card.isSpecial),
  );

  return (
    <div className="main">
      <OnboardingStepWizard
        handleGoToAnswer={handleGoToAnswer}
        currentOverviewStep={currentOverviewStep}
        currentOverviewSteps={currentOverviewSteps}
        currentOnboardingStep={currentOnboardingStep}
        currentOnboardingSteps={
          currentOnboardingSteps[currentOverviewStep].onboardingSteps
        }
        selectedValue={onboardingStepInfo.selectedValue}
        isNextEnabled={isNextEnabled}
      />
      {onboardingStepInfo.type === 'multi' ? (
        <OnboardingMultiContent
          onboardingStepInfo={onboardingStepInfo}
          handleCardSelected={handleCardSelected}
          handleGoToSection={handleGoToSection}
          handleAddContactInfo={handleAddContactInfo}
          handleNextStep={handleNextStep}
          handleSaveManagementWay={handleSaveManagementWay}
          handleCardInputChange={handleCardInputChange}
        />
      ) : (
        <div
          className={`onboarding-step py-14 container hv-100 d-flex flex-column justify-content-center align-items-center
          ${classNames({ 'onboarding-step-card': hasSpecialCard })}`}
        >
          <div className="row">
            <div className="col-12 text-center">
              <h2 className="onboard-title text-gray-2 font-weight-normal mt-4 mt-lg-0">
                {onboardingStepInfo.hero}
              </h2>
              <h4 className="onboard-desc text-gray-2 font-weight-normal mb-4">
                {isVideoFormat && (
                  <Fragment>
                    <div>{onboardingStepInfo.description[0]}</div>
                    <div>{onboardingStepInfo.description[1]}</div>
                    <br />
                    <div>
                      <small>
                        <b>{onboardingStepInfo.description[2]}</b>
                        {onboardingStepInfo.description[3]}
                      </small>
                    </div>
                  </Fragment>
                )}
                {!isVideoFormat && (
                  <Fragment>{onboardingStepInfo.description}</Fragment>
                )}
              </h4>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div
                className={`onboarding-row justify-content-center ${classNames({
                  'onboarding-row-mid': isBasicRequirement || isVideoFormat,
                })}`}
              >
                {onboardingStepInfo.cards.map((cardInfo, index) => (
                  <OnboardingCard
                    isBasicRequirement={isBasicRequirement}
                    isVideoFormat={isVideoFormat}
                    cardInfo={cardInfo}
                    key={String(index)}
                    selectedValue={onboardingStepInfo.selectedValue}
                    projectId={projectId}
                    projectName={onboardingStepInfo.project_name}
                    comment={onboardingStepInfo.comment}
                    projectBrief={onboardingStepInfo.project_brief}
                    projectPicture={onboardingStepInfo.project_picture}
                    projectAttachments={attachments}
                    references={references}
                    handleAddReference={handleAddReference}
                    handleDeleteReference={handleDeleteReference}
                    handleReferenceInputChange={handleReferenceInputChange}
                    handleCardInputChange={handleCardInputChange}
                    handleCardSelected={handleCardSelected}
                    handleProjectBriefInput={handleProjectBriefInput}
                    isUploadingProjectPicture={isUploadingProjectPicture}
                    isUploadingAttachment={isUploadingAttachment}
                    handleProjectUpload={handleProjectUpload}
                    handleRemoveUpload={handleRemoveUpload}
                    isSavingProject={isSavingProject}
                    budget={budget}
                    minBudget={minBudget}
                    maxBudget={maxBudget}
                    recommendedBudget={recommendedBudget}
                    handleBudgetChange={handleBudgetChange}
                    onPricingCalculatorMounted={onPricingCalculatorMounted}
                    freelancers={freelancers}
                    handleFetchFreelancers={handleFetchFreelancers}
                    freelancersPagination={freelancersPagination}
                    handleFreelancerBookNow={handleFreelancerBookNow}
                    handleFreelancerRequestABid={handleFreelancerRequestABid}
                    handleFreelancerDeleteABid={handleFreelancerDeleteABid}
                    isFetchingFreelancers={isFetchingFreelancers}
                    handleAddDeadline={handleAddDeadline}
                    handleShowFreelancerChooserPopup={
                      handleShowFreelancerChooserPopup
                    }
                    handleFreelancerCardClicked={handleFreelancerCardClicked}
                    deadline={deadline}
                    handleNextStep={handleNextStep}
                    handleGoToDashboard={handleGoToDashboard}
                    handleFreeCommentInputChange={handleFreeCommentInputChange}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="fixed-bottom container-fluid w-100 bg-white shadow-mod">
        {!['managed_marketplace', 'management_way', 'summary'].includes(key) &&
          renderBrowserButtons()}
      </div>
    </div>
  );
};

const findOtherCard = card => card.value === 'other';

const getOtherCard = (step, isMultiSections, section) =>
  isMultiSections
    ? step.cards[section].inner_cards.find(findOtherCard)
    : step.cards.find(findOtherCard);

OnboardingStep.propTypes = {
  projectId: PropTypes.number,
  handleCardInputChange: PropTypes.func,
  handleGoToAnswer: PropTypes.func,
  currentOnboardingStep: PropTypes.string,
  currentOverviewStep: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  currentOnboardingSteps: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
  handleCardSelected: PropTypes.func,
  handleNextStep: PropTypes.func,
  handlePrevStep: PropTypes.func,
  currentOverviewSteps: PropTypes.array,
  handleGoToSection: PropTypes.func,
  handleAddReference: PropTypes.func,
  handleDeleteReference: PropTypes.func,
  handleProjectBriefInput: PropTypes.func,
  handleReferenceInputChange: PropTypes.func,
  handleProjectUpload: PropTypes.func,
  handleRemoveUpload: PropTypes.func,
  isUploadingAttachment: PropTypes.bool,
  isUploadingProjectPicture: PropTypes.bool,
  isSavingProject: PropTypes.bool,
  budget: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minBudget: PropTypes.number,
  maxBudget: PropTypes.number,
  recommendedBudget: PropTypes.number,
  handleBudgetChange: PropTypes.func,
  onPricingCalculatorMounted: PropTypes.func,
  freelancers: PropTypes.array,
  freelancersPagination: PropTypes.object,
  handleFetchFreelancers: PropTypes.func,
  handleFreelancerBookNow: PropTypes.func,
  handleFreelancerRequestABid: PropTypes.func,
  handleFreelancerDeleteABid: PropTypes.func,
  isFetchingFreelancers: PropTypes.bool,
  handleShowFreelancerChooserPopup: PropTypes.func,
  handleFreelancerCardClicked: PropTypes.func,
  handleAddDeadline: PropTypes.func.isRequired,
  handleAddContactInfo: PropTypes.func,
  handleSaveManagementWay: PropTypes.func,
  handleGoToDashboard: PropTypes.func,
  handleFreeCommentInputChange: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/OnboardingStep/OnboardingStep.js